// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-cl{display:flex;flex-direction:column}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-cl-c{padding:10px;border-block-end:1px solid #eaeded}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-cl-c:first-of-type{padding-top:0}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-cl-c:last-of-type{padding-bottom:0;border-block-end:none}#awsccc-sb-ux-c #awsccc-sb-a .dark-mode-enabled .awsccc-u-cl-c{border-color:#414750}", ""]);
// Exports
module.exports = exports;
